export const SITE_URL = "https://milka.work";

export const RESUME_URL = "/pdf/Amilcar-Teixeira-Resume-2026.pdf";
